var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgAddCircleLine = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M9.16406 9.16699V5.83366H10.8307V9.16699H14.1641V10.8337H10.8307V14.167H9.16406V10.8337H5.83073V9.16699H9.16406ZM9.9974 18.3337C5.39502 18.3337 1.66406 14.6027 1.66406 10.0003C1.66406 5.39795 5.39502 1.66699 9.9974 1.66699C14.5997 1.66699 18.3307 5.39795 18.3307 10.0003C18.3307 14.6027 14.5997 18.3337 9.9974 18.3337ZM9.9974 16.667C13.6793 16.667 16.6641 13.6822 16.6641 10.0003C16.6641 6.31843 13.6793 3.33366 9.9974 3.33366C6.3155 3.33366 3.33073 6.31843 3.33073 10.0003C3.33073 13.6822 6.3155 16.667 9.9974 16.667Z",
  fill: "#1E1F2F"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgAddCircleLine);
export { ForwardRef as ReactComponent };